import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSchedule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.75 13.9167L13.9166 12.7501L10.8333 9.66675V5.83342H9.16663V10.3334L12.75 13.9167ZM9.99996 18.3334C8.84718 18.3334 7.76385 18.1147 6.74996 17.6772C5.73607 17.2397 4.85413 16.6459 4.10413 15.8959C3.35413 15.1459 2.76038 14.264 2.32288 13.2501C1.88538 12.2362 1.66663 11.1529 1.66663 10.0001C1.66663 8.8473 1.88538 7.76397 2.32288 6.75008C2.76038 5.73619 3.35413 4.85425 4.10413 4.10425C4.85413 3.35425 5.73607 2.7605 6.74996 2.323C7.76385 1.8855 8.84718 1.66675 9.99996 1.66675C11.1527 1.66675 12.2361 1.8855 13.25 2.323C14.2638 2.7605 15.1458 3.35425 15.8958 4.10425C16.6458 4.85425 17.2395 5.73619 17.677 6.75008C18.1145 7.76397 18.3333 8.8473 18.3333 10.0001C18.3333 11.1529 18.1145 12.2362 17.677 13.2501C17.2395 14.264 16.6458 15.1459 15.8958 15.8959C15.1458 16.6459 14.2638 17.2397 13.25 17.6772C12.2361 18.1147 11.1527 18.3334 9.99996 18.3334Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSchedule);
export default ForwardRef;
